import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useTimezone } from '../../store/slices/commonSlice';

const CallingContext = createContext();

export const useCallingData = () => {
  return useContext(CallingContext);
};

export const CallingContextProvider = ({ children }) => {
  const timezone = useTimezone();
  const today = toZonedTime(new Date(), timezone);
  const [informationData, setInformationData] = useState({});
  const [dispositionsData, setDispositionsData] = useState({});
  const [fieldsData, setFieldsData] = useState({});
  const [isPauseMode, setIsPauseMode] = useState(false);
  const [resetTimer, setResetTimer] = useState(false);
  const [mutedConference, setMutedConference] = useState([]);
  const [followUp, setFollowUp] = useState({
    date_and_time: startOfDay(today),
    isFollowUp: 'no'
  });

  const handleTimeReset = () => {
    setResetTimer(true);
    setTimeout(() => setResetTimer(true), 0);
  };

  return (
    <CallingContext.Provider
      value={{
        informationData,
        dispositionsData,
        fieldsData,
        followUp,
        isPauseMode,
        resetTimer,
        mutedConference,
        setInformationData,
        setDispositionsData,
        setFieldsData,
        setFollowUp,
        setIsPauseMode,
        setResetTimer,
        handleTimeReset,
        setMutedConference
      }}>
      {children}
    </CallingContext.Provider>
  );
};

CallingContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};
